import React from 'react';
import * as _ from 'lodash';

import { USER_ROLES } from '../../utilities/constants';
import { FormList, FormListItem, FormElement } from '../CommonFormComponents';
import { messageUtility } from '../../utilities/messageUtility';

import { Tel } from '../Tel'; // 電話番号入力フィールド
import { deleteControlCode } from '../../utilities/stringUtil';

import { TrashIcon } from '../icons/TrashIcon';
import Tippy from '../ReactTippy';

/**
 * 職長フォーム
 * @param values {object} 入力値
 * @param events {func} イベントハンドラ
 * @param messages {object} バリデーションメッセージ
 * @param image {string} 画像パス
 * @param readOnly {boolean} プレビュー表示
 */
export const ForemanForm = ({
  values,
  events,
  messages,
  image,
  readOnly = false,
}) => (
  <div className='contruction-detail-view__main contruction-detail-view__main--fixed contruction-detail-view__main--fix'>
    <FormList>
      <FormListItem label='ユーザー種別'>
        <FormElement>{USER_ROLES.foreman.name}</FormElement>
      </FormListItem>
      <FormListItem label='所属会社'>
        <FormElement>{values.company_name}</FormElement>
      </FormListItem>
      <FormListItem label='姓' required={true}>
        <FormElement validate={messages.name_sei}>
          <input
            type='text'
            name='name_sei'
            disabled={readOnly}
            placeholder='（例）山田'
            value={values.name_sei}
            onChange={e =>
              events.set('name_sei', deleteControlCode(e.target.value))
            }
            onBlur={e => events.isAvailable(e)}
          />
        </FormElement>
      </FormListItem>
      <FormListItem label='名' required={true}>
        <FormElement validate={messages.name_mei}>
          <input
            type='text'
            name='name_mei'
            placeholder='（例）太郎'
            disabled={readOnly}
            value={values.name_mei}
            onChange={e =>
              events.set('name_mei', deleteControlCode(e.target.value))
            }
            onBlur={e => events.isAvailable(e)}
          />
        </FormElement>
      </FormListItem>
      <FormListItem label='せい' required={true}>
        <FormElement validate={messages.kana_sei}>
          <input
            type='text'
            name='kana_sei'
            placeholder='（例）やまだ'
            disabled={readOnly}
            value={values.kana_sei}
            onChange={e =>
              events.set('kana_sei', deleteControlCode(e.target.value))
            }
            onBlur={e => events.isAvailable(e)}
          />
        </FormElement>
      </FormListItem>
      <FormListItem label='めい' required={true}>
        <FormElement validate={messages.kana_mei}>
          <input
            type='text'
            name='kana_mei'
            placeholder='（例）たろう'
            disabled={readOnly}
            value={values.kana_mei}
            onChange={e =>
              events.set('kana_mei', deleteControlCode(e.target.value))
            }
            onBlur={e => events.isAvailable(e)}
          />
        </FormElement>
      </FormListItem>
      <FormListItem label='電話番号'>
        <Tel
          value={values.tel}
          handleOnChange={events.set}
          setKey='tel'
          readOnly={readOnly}
          error={messages.tel}
          validate={e => events.isAvailable(e, 'tel')}
        />
      </FormListItem>
      <FormListItem label='ユーザーID' required={true}>
        <FormElement
          validate={messages.login_id}
          info={messageUtility.getMessage('I-001-252')}
        >
          <input
            type='text'
            name='login_id'
            disabled={readOnly}
            value={values.login_id}
            onChange={e =>
              events.set('login_id', deleteControlCode(e.target.value))
            }
            onBlur={e => events.isAvailable(e)}
          />
        </FormElement>
      </FormListItem>
      <FormListItem label='メールアドレス' isRecommended={true}>
        <FormElement
          validate={messages.email}
          info={messageUtility.getMessage('I-001-418')}
        >
          <input
            type='text'
            name='email'
            className='form-list__input-large'
            placeholder='メールアドレスを入力'
            disabled={readOnly}
            maxLength={255}
            value={values.email}
            onChange={e =>
              events.set('email', deleteControlCode(e.target.value))
            }
            onBlur={e => events.isAvailable(e)}
          />
        </FormElement>
      </FormListItem>
      <FormListItem label='アイコン画像'>
        <FormElement validate={messages.image}>
          <div className='form-list__img'>
            <div className='img-form-thumbnail'>
              {!_.isEmpty(image) && <img src={image} />}
            </div>
            <button
              className='btn-icon form-list__element--btn_delete'
              onClick={() => events.deleteImage()}
            >
              <TrashIcon className='icon--2_4x form-list__trash-icon' />
            </button>
          </div>
          <Tippy
            duration={10}
            arrow={true}
            arrowType='sharp'
            placement='bottom'
            html={renderTooltipContent()}
          >
            <label htmlFor='file-foreman-image' className='btn input-file'>
              ファイル選択
              <input
                type='file'
                disabled={readOnly}
                id='file-foreman-image'
                onChange={e => events.setImage(e)}
                accept='image/png,image/jpeg,image/gif'
              />
            </label>
          </Tippy>
        </FormElement>
      </FormListItem>
    </FormList>
  </div>
);

/**
 * Tooltip
 * @param data {string}
 */
const renderTooltipContent = () => {
  const rowStyle = {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '300px',
    maxHeight: '76px',
    color: '#FFF',
    fontSize: '10px',
    lineHeight: '18px',
    textAlign: 'left',
  };

  return (
    <React.Fragment>
      <div style={rowStyle}>
        JPEG、GIF、PNGファイルをアップロードしてください。
      </div>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/components/forms/Foreman.jsx